// @ts-strict-ignore
import type {EntryRowTypeHelpers} from 'common/query-builder/query-entry-section/row-types/types';
import {QuerySegmentEntry, SelectorTypeDefinitions} from 'common/query-builder/query-entry-section/types';
import {
  isAggregateUserFreqByGroupSegmentation,
  isEventBasedBehavioralSegmentation,
  isRevenueBehaviorSegmentation,
} from 'common/query-builder/query-entry-section/row-types/behavior/utils';
import {Segmentation} from 'common/types/reports/query';
import {isListOfObjectsSegment} from 'common/query-builder/query-block/segment-menu/types';
import {NumberOperator} from 'common/widgets/property-filter-menu/models/types';

// eslint-disable-next-line import/no-cycle
import {SegmentEntryRow} from './index';

export const helpers: EntryRowTypeHelpers<QuerySegmentEntry> = {
  component: SegmentEntryRow,
  getNewEntry: () => ({
    type: SelectorTypeDefinitions.Segment,
    filtersOperator: null,
    filters: [],
    event: null,
  }),
  isPlaceholder({entry}) {
    if (
      isEventBasedBehavioralSegmentation(entry.event) &&
      (entry.event.behavior?.property?.value === null ||
        entry.event.behavior?.event?.value === null ||
        entry.event.behavior?.aggregationOperator === null)
    ) {
      return true;
    }

    if (isRevenueBehaviorSegmentation(entry.event)) {
      return !entry.event.behavior.property.value;
    }

    if (isAggregateUserFreqByGroupSegmentation(entry.event)) {
      const validFilter = (event: Segmentation) => {
        const filterOperator = event.behavior.filters[0].filterOperator as NumberOperator;
        const filterValue = event.behavior.filters[0].filterValue;

        if (!filterOperator) {
          return false;
        }

        if ([NumberOperator.Between, NumberOperator.NotBetween].includes(filterOperator)) {
          return (
            Array.isArray(filterValue) && filterValue.length === 2 && filterValue.every((v) => typeof v === `number`)
          );
        }

        if ([NumberOperator.Set, NumberOperator.NotSet].includes(filterOperator)) {
          return true;
        }

        return (
          typeof filterValue === `number` ||
          (Array.isArray(filterValue) && filterValue.every((v) => typeof v === `number`))
        );
      };

      return (
        entry.event.behavior.filters.length === 0 ||
        !entry.event.behavior.filters[0].behavior.event ||
        !validFilter(entry.event)
      );
    }

    const segmentation = entry.event as Segmentation;

    if (isListOfObjectsSegment(segmentation) && Boolean(segmentation?.listItemGroup?.propertyName) === false) {
      return true;
    }

    return Boolean(entry.event) === false;
  },
  isIntermediatePlaceholder(row) {
    return this.isPlaceholder(row) && !!row.entry.event;
  },
};
